<template>
    <splash v-show="isLoading" :title="props.title + ' 준비중...'" />
    <splash v-show="isProc" title="잠시만 기다려 주세요." />
    <!-- <studyHeader v-if="!isLoading" /> -->
    <customHeader
        v-if="!isLoading"
        :title="props.title"
        @onClickBack="
            () => {
                emit('onClickEnd', null);
            }
        "
    />
    <q-page-container v-if="!isLoading">
        <q-page class="q-pa-md" style="height: calc((var(--vh, 1vh) * 100) - 150px)">
            <div class="row">
                <div class="col passage" style="height: calc((var(--vh, 1vh) * 100) - 70px)">
                    <qbankHeaderVue
                        :currentNo="arrHeaderNo[problem.problemNo - 1]"
                        :questionHeader="headerList[problem?.headerId] ? null : problem?.questionHeader"
                        :inputIdx="inputIdx"
                        :bookNm="bookNm"
                        @isChangeHeader="
                            () => {
                                isChangeHeader = true;
                            }
                        "
                        :reviewHeader="headerList[problem?.headerId]"
                    />
                </div>
                <div class="col answer" style="height: calc((var(--vh, 1vh) * 100) - 70px)">
                    <q-scroll-area v-if="!relationDialog" ref="scrollAreaRef" visible class="answer__scroll" style="height: 100%">
                        <div>
                            <problemChoice :p-content="problem" :isCsat="props.type === 'SAT'" v-if="problem" @setAnswer="setAnswer" />
                            <!-- <problemChoice :p-content="problem" v-if="problem" @setAnswer="setAnswer" /> -->
                        </div>
                        <!-- 정답표기 -->
                        <!-- <div>{{  problems[problemOrder]?.data.content.solution.answer.detail[0].answer  }}
                        </div> -->
                        <div>
                            <qbankAnswer :p-content="problem" v-if="isScored && problem?.data && problem?.result && problem?.result?.marking !== 'halfWrong'" @onIntersection="onIntersection" @setVideoStatus="setVideoStatus" />
                        </div>
                    </q-scroll-area>
                    <div v-if="relationDialog">
                        <ProblemRelation
                            :p-content="problem"
                            v-if="problem"
                            @setRelationAnswer="setRelationAnswer"
                            @onClose="
                                () => {
                                    relationDialog = false;
                                }
                            "
                        />
                    </div>
                </div>
            </div>
        </q-page>
        <FloatingNotify
            :text="msg"
            :icon="msgIcon"
            @resetMsg="
                () => {
                    msg = '';
                }
            "
        />
        <FloatingBtn
            :visible="nextBtn"
            @on-click="
                () => {
                    nextBtnAction();
                }
            "
            class="answer--next"
        />
        <FloatingBtn
            :visible="preBtn"
            position="left"
            @on-click="
                () => {
                    nextStep(false);
                }
            "
            class="answer--prev"
        />
        <FloatingBtn :visible="scoreBtn" text="정답 확인" text-only="true" bgColor="#FF4E7C" @on-click="setQuestionsResult" bottom="calc( 20vh - 55px )" class="answer--txt" />
    </q-page-container>
</template>

<script setup>
import splash from '@/components/template/splash.vue';
import { ref, onMounted, onUnmounted, watch, defineProps } from 'vue';
import { DialogStore } from '@/store/modules/dialog';
import modalLayer from '@/components/layouts/layer/modalLayer.vue';
import qbankHeaderVue from '@/components/qbank/header.vue';
import problemChoice from '@/components/qbank/problemChoice.vue';
import qbankAnswer from '@/components/qbank/qbankAnswer.vue';
import AnswerMarking from '@/components/qbank/answerMarking.vue';
import studyHeader from '@/components/layouts/header/studyHeader.vue';
import { getKrtExam, getKrtProblem } from '@/api/modules/qbank';
import { getHeaderTitle, getKreadScore, getHeaderText, getEtcInfo, getHeader } from '@/helpers/qbankParser/qbankDataParse';
import { useQuasar } from 'quasar';
import moment from 'moment';
import { soundEffect, soundTic } from '@/helpers/soundEffect';
import { StudyStore } from '@/store/modules/study';
import { useRouter } from 'vue-router';
import cqBtn from '@/components/quasar/cqBtn.vue';
import _ from 'lodash';
import { analysis, difficult, drill } from '@/helpers/qbankParser/qbankMeta';
import { getAnswer, postAnswer, postCornerEnd } from '@/api/modules/study';
import FloatingBtn from '@/components/quasar/floatingBtn.vue';
import FloatingNotify from '@/components/quasar/floatingNotify.vue';
import customHeader from '@/components/layouts/header/header.vue';
import ProblemRelation from '@/components/qbank/problemRelation.vue';
import { setHeaderNo4SAT } from '@/views/eval_qbank/exam_common.js';

// 학습준비화면 시간
const $q = useQuasar();
const router = useRouter();
const store = DialogStore();
const studyStore = StudyStore();
const isLoading = ref(null);
const isProc = ref(null);
const title = ref('심화학습');
const data = ref(null);
const diffTime = ref(null);
let startTime;
let baseTime;
const time = ref(null);
const questionHeader = ref(null);
const bookNm = ref(null);
const resultData = ref([]);
let allProblems = [];
let notif = null;
let problemMaps = [];
let problems = {};
let baseProblems = {};
let drillProblems = {};
let inputIdx = ref(0);
let answer = ref({});
let tmpAnswer = ref({});
let visibleScoring = false; // 채점 표시

//TODO: 차후 스토어로 변경 필요
let problemOrder = ref(1);
let problem = ref(null);
let notiType = 'first';
let isScored = false;
let isDrill = false;
let isAllChecked = false;

const relationDialog = ref(false);
const scrollAreaRef = ref(null);

const nextBtn = ref(false);
const preBtn = ref(false);
const scoreBtn = ref(false);
const msgComp = ref(false);
const msg = ref('');
const msgIcon = ref(null);
const isChangeHeader = ref(false);

let isViewMode = false;

let cornerLearningBaseTime = null;
let cornerTime = {
    passageReadStartTs: null,
    passageReadEndTs: null,
    passageReadTime: 0,
    videoViewStartTs: null,
    videoViewEndTs: null,
    videoViewTime: 0,
    cornerLearningStartTs: null,
    cornerLearningEndTs: null,
    cornerLearningTime: 0,
};

const headerList = ref({});

const props = defineProps({
    problemIds: {
        default: [],
    },
    type: {
        default: 'wrong',
    },
    title: {
        default: '오답노트',
    },
    examName: {
        default: '',
    },
    exprVersion: {
        default: '1.00.01',
    },
});

const emit = defineEmits(['onClickEnd']);

const initCoreReading = (rs, sdata) => {
    isLoading.value = false;
    const tmpEtcInfo = getEtcInfo(rs);
    data.value = {
        content: getHeaderText(rs),
        kread: tmpEtcInfo.kread,
        title: tmpEtcInfo.title,
        etcInfo: tmpEtcInfo,
        standardReadingTime: moment('2022-10-01 00:00:00').add(tmpEtcInfo.solveTime, 's').format('m분ss초'),
        solveTime: tmpEtcInfo.solveTime,
    };
    questionHeader.value = getHeader(rs);
    bookNm.value = tmpEtcInfo.bookNm;
    startTime = moment();
    cornerTime.cornerLearningStartTs = moment().format('YYYY-MM-DD HH:mm:ss');
    cornerLearningBaseTime = moment();
    problems[problemOrder.value]['answerStartTs'] = moment().format('YYYY-MM-DD HH:mm:ss');
    // setTimeout(() => {
    //     msg.value = '1번부터 4번까지 문제를 풀어보아요.';
    // }, 1000)
};

const nextStep = (v = true, no = -1) => {
    isProc.value = true;
    soundEffect('next');

    if (!isScored && no == -1 && problems[problemOrder.value] && problems[problemOrder.value]['result'] === null) {
        problems[problemOrder.value]['elapsedTime'] = problems[problemOrder.value]['elapsedTime'] + moment.duration(moment().diff(startTime)).asSeconds();
        problems[problemOrder.value]['answerEndTs'] = moment().format('YYYY-MM-DD HH:mm:ss');
    }
    startTime = moment();
    if (no == -1 && problems[problemOrder.value] && problems[problemOrder.value]['result'] !== null) {
        problems[problemOrder.value]['completeYn'] = true;
    }

    if (notiType === 'last' && v) {
        if (isChangeHeader.value) {
            headerList.value = { ...headerList.value, [problems[problemOrder.value].headerId]: document.getElementById('header_box').innerHTML };
            isChangeHeader.value = false;
        }
        // submitAnswer(problemOrder.value);
        return saveResult();
        // return router.push('/authenticreading');
    }

    if (no === -1) {
        if (isChangeHeader.value) {
            headerList.value = { ...headerList.value, [problems[problemOrder.value].headerId]: document.getElementById('header_box').innerHTML };
            isChangeHeader.value = false;
        }
        // submitAnswer(problemOrder.value);
    }

    if (no !== -1) {
        problemOrder.value = Number(no);
    } else if (!v) {
        problemOrder.value = problemOrder.value - 1;
    } else {
        problemOrder.value = problemOrder.value + 1;
    }

    if (!problems[problemOrder.value]['answerStartTs']) {
        problems[problemOrder.value]['answerStartTs'] = moment().format('YYYY-MM-DD HH:mm:ss');
    }

    questionHeader.value === getHeader(problems[problemOrder.value].data);
    if (problemOrder.value === 1) {
        notiType = 'first';
        // questionHeader.value = getHeader(problems[(problemOrder.value)].data);
    } else if (problemOrder.value === Object.keys(problems).length) {
        notiType = 'last';
    } else {
        notiType = 'middle';
    }
    // problemOrder.value = problemOrder.value = 2;
    // getKrtProblem({
    //   version: '1.00.01', problemId: problemMaps[problemOrder.value].problemId
    // }, setProblem)
    problem.value = {
        ...problems[problemOrder.value],
    };

    if (problems[problemOrder.value]['completeYn']) {
        notiType !== 'first' ? (preBtn.value = true) : (preBtn.value = false);
        nextBtn.value = true;
    } else if (problems[problemOrder.value]['answer'] !== null && !isScored) {
        notiType !== 'first' ? (preBtn.value = true) : (preBtn.value = false);
        notiType !== 'last' ? (nextBtn.value = true) : (nextBtn.value = false);
    } else if (!problems[problemOrder.value]['completeYn'] || isScored) {
        preBtn.value = false;
        nextBtn.value = false;
    } else {
        notiType !== 'first' ? (preBtn.value = true) : (preBtn.value = false);
        notiType !== 'last' ? (nextBtn.value = true) : (nextBtn.value = false);
    }
    // setNotiNavigation(problems[problemOrder.value]);

    // notiNav !== null && notiNav();
    // notiNavBack !== null && notiNavBack();
    // notiNav = null;
    // notiNavBack = null;
    // startTime = moment();

    setScrollPosition();
    isProc.value = false;
};

const arrHeaderNo = ref([]); // 지문 상단 번호
const initExams = async () => {
    // TODO: store 에 코어리딩 문제 저장
    // rs.examMaps
    if (props.problemIds && props.problemIds.length > 0) {
        let problemArrId = props.problemIds;
        getKrtExam(
            {
                // version: '1.00.01', examNm: 'KRT_02_17_N_02_C'
                version: studyStore.exprVersion,
                examNm: props.examName,
                // version: studyStore.exprVersion, examNm: 'KRT_02_T1'
            },
            async (rs) => {
                // console.log('--getKrtExam- examIds[0]-', rs.examIds[0]);
                // console.log('--getKrtExam-rs-', rs);
                // console.log('--getKrtExam-headerId-', rs.examMaps[107171][2].property.headerId);

                const tmpPdata = {};
                rs.examMaps[rs.examIds[0]].forEach((e, i) => {
                    tmpPdata[i + 1] = { data: { content: { headerId: e.property.headerId } } };
                    // console.log('--tmpPdata-e-',e.property.headerId)
                    // return { data: { content: { headerId: e.property.headerId } } };
                });
                // console.log('--tmpPdata-e-', tmpPdata);
                setHeaderNo4SAT(arrHeaderNo, tmpPdata);

                const exId = rs.examIds[0];
                const problemArr = rs.examMaps[exId];

                await Promise.all(
                    problemArrId.map((item, index) => {
                        return getKrtProblem(
                            {
                                version: item.exprVersion,
                                problemId: item.problemId,
                                // version: '1.00.01', problemId: 382222
                            },
                            (r) => {
                                let pData = {
                                    examName: item.examName,
                                    // problemNo: index + 1,
                                    problemNo:
                                        _.findIndex(problemArr, function (o) {
                                            return o.problemId === r.content.problemId;
                                        }) + 1,
                                    problemId: r.content.problemId,
                                    analysisOrd: item.analysisOrd,
                                    etcInfo: getEtcInfo(r),
                                    data: r,
                                    elapsedTime: 0,
                                    answer: null,
                                    reAnswer: null,
                                    videoTime: 0,
                                    relationResult: null,
                                    // 하단 네비 조정을 위한 변수
                                    result: null, // 채점 여부및 1,2차 정오답
                                    completeYn: false, // 채점및 풀이 확인 완료여부
                                    scrollCheck: false, // 해설 끝까지 확인 , 스크롤 하단 갔었는지 체크
                                    relationId: r.content.property.problem?.relations?.length > 0 ? r.content.property.problem?.relations[0].relationId : null, // 확인 문제 있는지 여부
                                    // relationId: null,           // 확인 문제 있는지 여부
                                    completeVideo: false, // 영상 시청 여부
                                    correct: r.content.solution.answer.detail[0].answer,
                                    // TODO: 큐뱅크 해설영상 파싱필요
                                    // videoUrl: null,              // 해설 영상 여부
                                    videoUrl: r.content.property.problem.listen.includes('mp4') ? process.env.VUE_APP_DS_QBANK_ASSET_URL + r.content.property.problem.listen : null,
                                    // videoUrl: r.content.property.problem.listen !== '' ? process.env.VUE_APP_DS_QBANK_ASSET_URL + r.content.property.problem.listen : null,
                                    // videoUrl: 'https://media5jvqbd.fmkorea.com/files/attach/new2/20210301/2063168106/62449231/3424305738/b1b4e7075cece7bf3b0174253e99b524.mp4#t=1, 10',              // 해설 영상 여부
                                    problemClassCode: '1',
                                    questionHeader: getHeader(r),
                                    headerId: r.content.property.header.headerId,
                                };

                                problems = {
                                    // ...problems, [item.analysisOrd]: pData
                                    ...problems,
                                    [index + 1]: pData,
                                };

                                if (index === 0) {
                                    initCoreReading(r);
                                }
                            },
                        );
                    }),
                );
                // console.log('--getKrtExam-problems-',problems)

                problem.value = problems[1];
                problemOrder.value = 1;
                if (Object.keys(problems).length === 1) {
                    notiType = 'last';
                } else {
                    notiType = 'first';
                }
            },
        );
    }
};

onMounted(() => {
    // console.log(props.type);
    soundEffect('enter');
    isLoading.value = true;
    setTimeout(() => {
        initExams();
    }, 1000);
});

onUnmounted(() => {
    isLoading.value = true;
    store.openModal(false);
});

watch(
    () => props.problemIds,
    (newValue) => {
        isLoading.value = true;
        scoreBtn.value = false;
        preBtn.value = false;
        nextBtn.value = false;
        setTimeout(() => {
            initExams();
        }, 1000);
    },
);

const setAnswer = (val) => {
    if (problems[problemOrder.value]?.result !== null) {
        problems[problemOrder.value]['reAnswer'] = val;
        // console.log(problems[problemOrder.value]['reAnswer']);
        scoreBtn.value = true;
    } else {
        problems[problemOrder.value]['answer'] = val;
        scoreBtn.value = true;
    }
};

const setRelationAnswer = (val) => {
    problems[problemOrder.value]['completeYn'] = true;
    problems[problemOrder.value]['relationResult'] = val;
    preBtn.value = true;
    nextBtn.value = true;
};

const nextBtnAction = () => {
    if (notiType === 'last' && isScored && !isDrill && Object.keys(drillProblems).length > 0) {
        drillInit();
    } else {
        if (isScored) {
            // problems[problemOrder.value]['completeYn'] = true;
        }
        nextStep();
    }
};

let lastCallTime = 0; // 마지막 호출 시간을 저장할 변수

const setQuestionsResult = () => {
    // soundEffect('next');
    // notiAdditionalNav = null;

    const now = Date.now();
    // console.log(`now - lastcall : ${now - lastCallTime}`);
    if (now - lastCallTime < 900) {
        // console.log('중복 호출 방지');
        return;
    }
    lastCallTime = now; // 현재 시간을 마지막 호출 시간으로 업데이트

    // console.log('==> setQuestionsResult');
    // console.log('==> problems[value]: ', problems[problemOrder.value]);
    // console.log('==> problems[value].result : ', problems[problemOrder.value].result);

    if (problems[problemOrder.value]['result'] !== null) {
        // console.log('==> 결과가 있을시');
        // console.log('==> problems[problemOrder.value].data.content.solution.answer.detail[0].answer : ', problems[problemOrder.value].data.content.solution.answer.detail[0].answer);
        // console.log('==> problems[problemOrder.value].reAnswer : ', problems[problemOrder.value].reAnswer);
        // console.log(
        //     '==> problems[problemOrder.value].data.content.solution.answer.detail[0].answer === problems[problemOrder.value].reAnswer : ',
        //     problems[problemOrder.value].data.content.solution.answer.detail[0].answer === problems[problemOrder.value].reAnswer,
        // );
        soundEffect(problems[problemOrder.value].data.content.solution.answer.detail[0].answer === problems[problemOrder.value].reAnswer ? 'correct' : 'wrong');
        problems[problemOrder.value]['result'] = { marking: problems[problemOrder.value].data.content.solution.answer.detail[0].answer === problems[problemOrder.value].reAnswer ? 'halfRight' : 'wrong', answer: problems[problemOrder.value].answer };
        // console.log('==> problems[problemOrder.value].result : ', problems[problemOrder.value].result);
        problem.value = { ...problems[problemOrder.value] };
    } else {
        // console.log('==> 결과가 없을시');
        isAllChecked = false;
        if (problems[problemOrder.value]['result'] === null) {
            problems[problemOrder.value]['elapsedTime'] = problems[problemOrder.value]['elapsedTime'] + moment.duration(moment().diff(startTime)).asSeconds();
            problems[problemOrder.value]['answerEndTs'] = moment().format('YYYY-MM-DD HH:mm:ss');
        }
        startTime = moment();
        const tmpData = [];
        const tmpIsRight = problems[problemOrder.value].data.content.solution.answer.detail[0].answer === problems[problemOrder.value].answer;
        problems[problemOrder.value].result = { marking: tmpIsRight ? 'right' : 'wrong', answer: problems[problemOrder.value].answer };
        isScored = true;
        problem.value = { ...problems[problemOrder.value] };
        // if (problems[problemOrder.value].data.content.solution.answer.detail[0].answer !== problems[problemOrder.value].answer) {
        //     msgIcon.value = '';
        //     msg.value = '오답은 한 번 다시 풀어보아요.';
        //     // $q.notify({
        //     //   message: '오답은 한 번 다시 풀어보아요.',
        //     //   // color: 'secondary',
        //     //   position: 'right',
        //     //   timeout: 1000
        //     // })
        // }
    }
    scoreBtn.value = false;
    preBtn.value = false;
    nextBtn.value = false;
};

// 스크롤 하단시 액션
const onIntersection = () => {
    // console.log(' onIntersection !!!!!!!!!!!!!!!');
    if (problems[problemOrder.value]['scrollCheck'] !== true) {
        problems[problemOrder.value]['scrollCheck'] = true;
        if (problem.value?.result?.marking === 'right') {
            problems[problemOrder.value]['completeYn'] = true;
            problems[problemOrder.value]['completeVideo'] = true;
            notiType !== 'first' || isDrill ? (preBtn.value = true) : (preBtn.value = false);
            nextBtn.value = true;
        } else if (problem.value?.result?.marking === 'halfRight') {
            if (problems[problemOrder.value]['videoUrl'] === null) {
                problems[problemOrder.value]['completeYn'] = true;
                problems[problemOrder.value]['completeVideo'] = true;
                notiType !== 'first' || isDrill ? (preBtn.value = true) : (preBtn.value = false);
                nextBtn.value = true;
            } else {
                msgIcon.value = '';
                // msg.value = '확인해야 할 해설영상이 있어요!';
                msg.value = '문제풀이 영상을 확인하세요.';
            }
        } else {
            if (problems[problemOrder.value]['videoUrl'] !== null) {
                msgIcon.value = '';
                // msg.value = '확인해야 할 해설영상이 있어요!';
                msg.value = '문제풀이 영상을 확인하세요.';
            } else if (problems[problemOrder.value]['videoUrl'] === null && problems[problemOrder.value]['relationId'] === null) {
                problems[problemOrder.value]['completeYn'] = true;
                notiType !== 'first' || isDrill ? (preBtn.value = true) : (preBtn.value = false);
                nextBtn.value = true;
            } else {
                notiType !== 'first' || isDrill ? (preBtn.value = true) : (preBtn.value = false);
                nextBtn.value = true;
            }
        }
        // setNotiNavigation(problems[problemOrder.value]);
    }
};

const setVideoStatus = () => {
    // console.log('video complete');
    problems[problemOrder.value]['completeVideo'] = true;
    if (problems[problemOrder.value]['relationId'] === null) {
        problems[problemOrder.value]['completeYn'] = true;
        notiType !== 'first' || isDrill ? (preBtn.value = true) : (preBtn.value = false);
    }
    notiType !== 'first' || isDrill ? (preBtn.value = true) : (preBtn.value = false);
    nextBtn.value = true;
    // setNotiNavigation(problems[problemOrder.value]);
    // console.log(problems[problemOrder.value]);
};

const setScrollPosition = (val = 0) => {
    try {
        scrollAreaRef.value.setScrollPosition('vertical', 0);
    } catch (error) {
        //
    }
};

const drillInit = () => {
    title.value = '드릴학습 준비중...';
    isLoading.value = true;
    baseProblems = problems;
    problems = drillProblems;
    problem.value = drillProblems[1];
    // isScored = false;
    isDrill = true;
    notiType = 'first';
    // submitAnswer(4, 'base');
    nextStep(false, 1);
    setTimeout(() => {
        isLoading.value = false;
    }, 1000);
    // problemOrder.value = 1;
};

const saveResult = () => {
    isProc.value = true;
    Object.values(problems).forEach((tmpVal) => {
        tmpVal.reviewContents = isChangeHeader.value ? document.getElementById('header_box').innerHTML : null;
        tmpVal.correctYn = tmpVal.result === null ? null : tmpVal.result?.marking === 'right';
        tmpVal.reCorrectYn = tmpVal.reAnswer === null ? null : tmpVal.result?.marking === 'halfRight' ? true : false;
        tmpVal.answerStatus = 'COMPLETE';
        if (headerList.value[tmpVal.headerId]) {
            tmpVal.reviewContents = headerList.value[tmpVal.headerId];
        }
        delete tmpVal.data;
        delete tmpVal.result;

        delete tmpVal.problemNo;
        delete tmpVal.analysisOrd;
        delete tmpVal.etcInfo;
        delete tmpVal.videoTime;
        delete tmpVal.relationResult;
        delete tmpVal.scrollCheck;
        delete tmpVal.relationId;
        delete tmpVal.completeVideo;

        delete tmpVal.videoUrl;
        delete tmpVal.completeVideo;
        delete tmpVal.questionHeader;
        delete tmpVal.headerId;
    });
    emit('onClickEnd', problems);
    // if (isViewMode) {
    //     router.push('/vocabularylearning');
    //     studyStore.currentInfo.studyTree = studyStore.currentInfo.studyTree + 1;
    // } else {
    //     postCornerEnd({
    //         type: 'earnest', data: {
    //             examName: studyStore.process.exam.examCode + '_C',
    //             learningType: studyStore.process.exam.learningType
    //         }
    //     }, () => {
    //         router.push('/vocabularylearning');
    //         studyStore.process.studyTree = studyStore.process.studyTree + 1;
    //         // postUserJson(JSON.stringify(studyStore.process), (rs) => {
    //         //   //
    //         // });
    //     })
    // }
};

// const submitAnswer = (num, target = null) => {
//     let tmpVal = { ...problems[num] };
//     if (target === 'drill') {
//         tmpVal = { ...drillProblems[num] }
//     }
//     if (target === 'base') {
//         tmpVal = { ...baseProblems[num] }
//     }
//     if (tmpVal) {

//         tmpVal.answer = tmpVal.answer;
//         tmpVal.reAnswer = tmpVal.reAnswer ? tmpVal.reAnswer : null;
//         tmpVal.elapsedTime = tmpVal.elapsedTime;
//         tmpVal.reviewContents = isChangeHeader.value ? document.getElementById('header_box').innerHTML : null;
//         tmpVal.correctYn = tmpVal.result === null ? null : (tmpVal.result?.marking === 'right');
//         tmpVal.reCorrectYn = tmpVal.reAnswer === null ? null : tmpVal.result?.marking === 'halfRight' ? true : false;
//         tmpVal.answerStatus = isScored ? 'COMPLETE' : 'NOT_SCORE';

//         delete tmpVal.data;
//         delete tmpVal.result;
//         delete tmpVal.rightAnswer;

//         delete tmpVal.problemNo;
//         delete tmpVal.analysisOrd;
//         delete tmpVal.etcInfo;
//         delete tmpVal.videoTime;
//         delete tmpVal.relationResult;
//         delete tmpVal.scrollCheck;
//         delete tmpVal.relationId;
//         delete tmpVal.completeVideo;

//         delete tmpVal.videoUrl;
//         delete tmpVal.completeVideo;

//         const saveData = {
//             examName: studyStore.process.exam.examCode + '_R',
//             exprVersion: studyStore.exprVersion,
//             learningType: studyStore.process.exam.learningType,
//             cornerTime: {
//                 cornerLearningStartTs: cornerTime.cornerLearningStartTs,
//                 cornerLearningEndTs: moment().format('YYYY-MM-DD HH:mm:ss'),
//                 cornerLearningTime: (moment.duration(moment().diff(moment(cornerTime.cornerLearningStartTs))).asSeconds())
//             },
//             submission: { ...tmpVal }
//         }
//         console.log('saveData %%%%%%%%%%%%%%%%%%%%%%%%%');
//         console.log('saveData :' + saveData);
//         console.log(JSON.stringify(saveData));
//         if (!isViewMode) {
//             // postAnswer({ type: 'earnest', data: saveData }, () => {
//             //     console.log('save Answer!');
//             // });
//         }

//         cornerTime.cornerLearningStartTs = moment().format('YYYY-MM-DD HH:mm:ss');
//     }
// }
</script>

<style scoped lang="scss">
.word-chart_item {
    padding: 0px 20px;
    text-align: center;
}

.q-dialog__backdrop {
    width: 100vw;
    height: 100vh;
    top: 0px;
    position: fixed;
    z-index: 6000;
    pointer-events: all;
    outline: 0;
    background: rgb(23 20 20 / 40%);
}

.passage {
    + .answer {
        &::before {
            content: '';
            position: absolute;
            top: 46%;
            left: 0;
            width: 1px;
            height: 91%;
            max-height: 974px;
            background: $color_gray_500;
            @include transform(translateY(-50%));
        }
    }
}

.answer {
    position: relative;
    // padding: 0 4.17vmin;

    &__scroll {
        padding: 0 5.17vmin 3.33vmin 4.08vmin;
        // padding-right: 5.17vmin;
        // padding-bottom: 3.33vmin;
    }
}

::v-deep {
    .q-scrollarea__content {
        padding-bottom: 3.33vmin;
    }

    .q-scrollarea__bar--v,
    .q-scrollarea__thumb--v {
        width: 0.3vw;
    }
}
</style>
